import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { getTestProps } from '@lusha-ui/core';
import { CloseIcon } from '@lusha-ui/icons';
import { colors } from '@lusha-ui/theme';
import React, { useCallback } from 'react';
import { useKeyContext } from 'use-key-context';
function ModalCloseButton(props) {
    const { onClose } = props;
    const testId = useKeyContext('close');
    const handleClose = useCallback((e) => {
        onClose();
        e.stopPropagation();
    }, [onClose]);
    return (_jsx("div", Object.assign({}, getTestProps(testId), { onClick: handleClose, css: css `
        //position: absolute;
        //top: 0;
        //right: 0;
        padding: 8px;
        cursor: pointer;
        z-index: 10;
      `, children: _jsx(CloseIcon, { color: colors.darkGrey }) })));
}
export default ModalCloseButton;
